import { TableCell, TableRow, Table, TableBody, Collapse } from "@mui/material";
import { AreaByScopeOfWork } from "../../../types/scope-of-work.interface";
import { AreaRow } from "./AreaRow";

interface AreasListProps {
  areas: AreaByScopeOfWork[];
  isExpanded: boolean;
  expandedAreas: Set<string>;
  onToggleArea: (areaUid: string) => void;
  getAreaTime: (areaUid: string) => string | undefined;
}

export const AreasList = ({
  areas,
  isExpanded,
  expandedAreas,
  onToggleArea,
  getAreaTime,
}: AreasListProps) => {
  return (
    <TableRow>
      <TableCell colSpan={5} sx={{ p: 0, border: "none" }}>
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Table size="small" sx={{ width: "100%", tableLayout: "fixed" }}>
            <TableBody>
              {areas.map((area) => (
                <AreaRow
                  key={area.uid}
                  area={area}
                  areaTime={getAreaTime(area.areaUid)}
                  isExpanded={expandedAreas.has(area.uid)}
                  onToggleExpand={() => onToggleArea(area.uid)}
                />
              ))}
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
